export default "__VITE_ASSET__DihM309W__"